import { useInfiniteQuery } from '@tanstack/react-query';

import { getTrendings } from '../functions/trendings';
import { TrendingsParams } from '../models/trendingModels';

export const useGetTrendings = (params: TrendingsParams) =>{

  const pivot = params.n ?? '0';
  return useInfiniteQuery({
    queryKey: ['get-trendings', params.limit, params.location, params.lastDistance, params.lastId, params.n],
    queryFn: getTrendings,
    initialPageParam: params.location ? {
      lastId: params.lastId ?? '',
      lastDistance: params.lastDistance ?? 0
    } : pivot,
    getNextPageParam: (lastPage) => {
      if (lastPage.last) {
        return lastPage.last;
      } else {
        return null;
      }
    }
  });
}
